import { initialModel } from './streams'
import { add, rotate } from './vectors'

var canvas, ctx

function init() {
    canvas = document.getElementById("canvas")
    ctx = canvas.getContext('2d')
    //let size = initialModel.canvas_size
    let size = 500
    canvas.width = size
    canvas.height = size
    ctx.transform(1, 0, 0, -1, 0, canvas.height)
}

var bcanvas, bctx

function initBackground() {
    bcanvas = document.getElementById("background")
    bctx = bcanvas.getContext('2d')
    //let size = initialModel.canvas_size
    let size = 500
    bcanvas.width = size
    bcanvas.height = size
    bctx.transform(1, 0, 0, -1, 0, canvas.height)
}

var colors = {
    red: '#FF4136',
    blue: '#0074D9',
    black: '#111111',
    orange: '#FF851B'
}

function draw_robot_part(part, heading, pos, pixels_per_meter) {
    ctx.beginPath()
    var vecs = part.part
    if (part.hasOwnProperty('initial_angle')) {
        vecs = rotate_vecs(part.part, part.initial_angle)
    }
    var added = add_vec(vecs, { x: part.x, y: part.y })
    var rotated = rotate_vecs(added, heading)
    ctx.fillStyle = colors[part.color]
    draw_vecs(ctx, pixels_per_meter, pos.x, pos.y, rotated)
    ctx.closePath()
    if (part.hasOwnProperty('stroke')) {
        ctx.stroke()
    } else {
        ctx.fill()
    }
}

function draw_vecs(ctx, conversion, x, y, vecs) {
    for (var i=0; i<vecs.length; i++) {
        let new_x = vecs[i].x + x
        let new_y = vecs[i].y + y
        if (i == 0) {
            ctx.moveTo(new_x * conversion, new_y * conversion)
        } else {
            ctx.lineTo(new_x * conversion, new_y * conversion)
        }
    }
}

function add_vec(vecs, vec2) {
    return vecs.map(vec => add(vec, vec2))
}

function rotate_vecs(vecs, angle) {
    return vecs.map(vec => rotate(vec, angle))
}

var feet_per_meter = 3.28084

var balancing_stone = [
    { x: -1, y: 1 },
    { x: -1, y: -1 },
    { x: 1, y: -1 },
    { x: 1, y: 1 }
]

var height_jewel_mount = 9.75/12
var width_jewel_mount = 1.875/12

var jewel_mount = [
    { x: -width_jewel_mount, y: height_jewel_mount/2 },
    { x: -width_jewel_mount, y: -height_jewel_mount/2 },
    { x: width_jewel_mount, y: -height_jewel_mount/2 },
    { x: width_jewel_mount, y: height_jewel_mount/2 }
]

var field_parts = [
    { part: balancing_stone, x: 2, y: 10, color: 'red' },
    { part: balancing_stone, x: 2, y: 4, color: 'red' },
    { part: balancing_stone, x: 10, y: 10, color: 'blue' },
    { part: balancing_stone, x: 10, y: 4, color: 'blue' },
    { part: jewel_mount, x: 1.875/12, y: 10, color: 'black' },
    { part: jewel_mount, x: 1.875/12, y: 4, color: 'black' },
    { part: jewel_mount, x: 12 - 1.875/12, y: 10, color: 'black' },
    { part: jewel_mount, x: 12 - 1.875/12, y: 4, color: 'black' },
]

// actually 3.75 but looks weird
var jewel_diameter = 2.75/12

var jewels = [
    { x: width_jewel_mount, y: 10 + height_jewel_mount/4, color: 'red' },
    { x: width_jewel_mount, y: 10 - height_jewel_mount/4, color: 'blue' },
    { x: width_jewel_mount, y: 4 + height_jewel_mount/4, color: 'red' },
    { x: width_jewel_mount, y: 4 - height_jewel_mount/4, color: 'blue' },
    { x: 12 - width_jewel_mount, y: 10 + height_jewel_mount/4, color: 'red' },
    { x: 12 - width_jewel_mount, y: 10 - height_jewel_mount/4, color: 'blue' },
    { x: 12 - width_jewel_mount, y: 4 + height_jewel_mount/4, color: 'red' },
    { x: 12 - width_jewel_mount, y: 4 - height_jewel_mount/4, color: 'blue' }
]

var cryptobox_tape = [
    { x: -15/12, y: -1.1 },
    { x: 0, y: 11/12 },
    { x: 15/12, y: -1.1 }
]

var cryptobox_line = [
    { x: -12/12, y: -7/12 },
    { x: 12/12, y: -7/12 }
]

var cryptobox_triangles = [
    { part: cryptobox_tape, x: 3, y: 1, color: 'red', angle: 0 },
    { part: cryptobox_line, x: 3, y: 1, color: 'red', angle: 0 },
    { part: cryptobox_tape, x: 1, y: 7, color: 'red', angle: -1.57 },
    { part: cryptobox_line, x: 1, y: 7, color: 'red', angle: -1.57 },
    { part: cryptobox_tape, x: 9, y: 1, color: 'blue', angle: 0 },
    { part: cryptobox_line, x: 9, y: 1, color: 'blue', angle: 0 },
    { part: cryptobox_tape, x: 11, y: 7, color: 'blue', angle: 1.57 },
    { part: cryptobox_line, x: 11, y: 7, color: 'blue', angle: 1.57 }
]

var pit_line = [
    { x: 0, y: -1 },
    { x: 0, y: 1 }
]

var diagonal = Math.sqrt(2)

var turned_pit_line = [
    { x: 0, y: diagonal - 1.3/12 },
    { x: 0, y: -diagonal + 1.3/12 }
]

var red_pit_lines = [
    { part: pit_line, x: 6 - 1/12, y: 11, color: 'red', angle: 0 },
    { part: turned_pit_line, x: 5, y: 9, color: 'red', angle: -0.785398 },
    { part: pit_line, x: 4 + .8/12, y: 7, color: 'red', angle: 0 },
    { part: turned_pit_line, x: 5, y: 5, color: 'red', angle: 0.785398 },
    { part: pit_line, x: 6 - 1/12, y: 3, color: 'red', angle: 0 },
    { part: pit_line, x: 6 - 1/12, y: 1, color: 'red', angle: 0 }
]

var blue_pit_lines = [
    { part: pit_line, x: 6 + 1/12, y: 11, color: 'blue', angle: 0 },
    { part: turned_pit_line, x: 7, y: 9, color: 'blue', angle: 0.785398 },
    { part: pit_line, x: 8 - .8/12, y: 7, color: 'blue', angle: 0 },
    { part: turned_pit_line, x: 7, y: 5, color: 'blue', angle: -0.785398 },
    { part: pit_line, x: 6 + 1/12, y: 3, color: 'blue', angle: 0 },
    { part: pit_line, x: 6 + 1/12, y: 1, color: 'blue', angle: 0 }
]

var cryptobox_column = [
    { x: 0, y: 2/12 },
    { x: 0, y: -2/12 }
]

var mid = 1.375/12 / 2

var space_left = (2 - 1.375/12)/3

var cryptobox_columns = [
    { part: cryptobox_column, x: 2 + mid, y: 2/12, color: 'red', angle: 0 },
    { part: cryptobox_column, x: 2 + mid + space_left, y: 2/12, color: 'red', angle: 0 },
    { part: cryptobox_column, x: 2 + mid + 2 * space_left, y: 2/12, color: 'red', angle: 0 },
    { part: cryptobox_column, x: 2 + mid + 3 * space_left, y: 2/12, color: 'red', angle: 0 },
    { part: cryptobox_column, x: 8 + mid, y: 2/12, color: 'blue', angle: 0 },
    { part: cryptobox_column, x: 8 + mid + space_left, y: 2/12, color: 'blue', angle: 0 },
    { part: cryptobox_column, x: 8 + mid + 2 * space_left, y: 2/12, color: 'blue', angle: 0 },
    { part: cryptobox_column, x: 8 + mid + 3 * space_left, y: 2/12, color: 'blue', angle: 0 },

    { part: cryptobox_column, y: 6 + mid, x: 2/12, color: 'red', angle: -1.57 },
    { part: cryptobox_column, y: 6 + mid + space_left, x: 2/12, color: 'red', angle: -1.57 },
    { part: cryptobox_column, y: 6 + mid + 2 * space_left, x: 2/12, color: 'red', angle: -1.57 },
    { part: cryptobox_column, y: 6 + mid + 3 * space_left, x: 2/12, color: 'red', angle: -1.57 },
    { part: cryptobox_column, y: 6 + mid, x: 12 - 2/12, color: 'blue', angle: -1.57 },
    { part: cryptobox_column, y: 6 + mid + space_left, x: 12 - 2/12, color: 'blue', angle: -1.57 },
    { part: cryptobox_column, y: 6 + mid + 2 * space_left, x: 12 - 2/12, color: 'blue', angle: -1.57 },
    { part: cryptobox_column, y: 6 + mid + 3 * space_left, x: 12 - 2/12, color: 'blue', angle: -1.57 }
]

var picture_line = [
    { x: 0, y: 11/12/2 },
    { x: 0, y: -11/12/2 }
]

var pictures = [
    { part: picture_line, x: 1/12/2, y: 4 - 5/12 - 11/12/2 },
    { part: picture_line, x: 1/12/2, y: 10 - 5/12 - 11/12/2 },
    { part: picture_line, x: 12 - 1/12/2, y: 4 + 5/12 + 11/12/2 },
    { part: picture_line, x: 12 - 1/12/2, y: 10 + 5/12 + 11/12/2 }
]

function draw_pit_lines(lines, pixels_per_meter) {
    ctx.lineCap = "round"
    var original_width = ctx.lineWidth
    var original_color = ctx.strokeStyle
    ctx.lineWidth = 2/12 * pixels_per_meter / feet_per_meter

    ctx.beginPath()
    for (let part of lines) {
        ctx.strokeStyle = colors[part.color]
        let rotated = rotate_vecs(part.part, part.angle)
        draw_vecs(ctx, 1/feet_per_meter * pixels_per_meter, part.x, part.y, rotated)
    }
    ctx.stroke()

    ctx.strokeStyle = original_color
    ctx.lineWidth = original_width
    ctx.lineCap = "butt"
}

function draw_field(pixels_per_meter) {
    bctx.fillStyle = "#AAAAAA"
    bctx.fillRect(0, 0, bcanvas.width, bcanvas.height)

    let tile = 12 / feet_per_meter / 6 * pixels_per_meter

    bctx.setLineDash([10, 5])
    for (var j=1; j<=5; j++) {
        bctx.fillStyle = "#000000"
        bctx.beginPath()
        bctx.moveTo(j * tile, 0)
        bctx.lineTo(j * tile, canvas.height)
        bctx.stroke()
    }

    for (var j=1; j<=5; j++) {
        bctx.fillStyle = "#000000"
        bctx.beginPath()
        bctx.moveTo(0, j * tile)
        bctx.lineTo(canvas.width, j * tile)
        bctx.stroke()
    }
    bctx.setLineDash([])

    /*
    for (let part of field_parts) {
        bctx.beginPath()
        bctx.fillStyle = colors[part.color]
        draw_vecs(bctx, 1/feet_per_meter * pixels_per_meter, part.x, part.y, part.part)
        bctx.closePath()
        if (part.hasOwnProperty('stroke')) {
            bctx.stroke()
        } else {
            bctx.fill()
        }
    }
    */

    /*
    for (let jewel of jewels) {
        bctx.beginPath()
        let jx = jewel.x * 1/feet_per_meter*pixels_per_meter
        let jy = jewel.y * 1/feet_per_meter*pixels_per_meter
        let jr = jewel_diameter/2 * 1/feet_per_meter*pixels_per_meter
        bctx.fillStyle = colors[jewel.color]
        bctx.arc(jx, jy, jr, 0, 2*Math.PI, false)
        bctx.fill()
    }
    */

    let original_width = bctx.lineWidth
    let original_color = bctx.strokeStyle
    bctx.lineWidth = 2/12 * pixels_per_meter / feet_per_meter

    /*
    for (let part of cryptobox_triangles) {
        bctx.beginPath()
        bctx.strokeStyle = colors[part.color]
        let rotated = rotate_vecs(part.part, part.angle)
        draw_vecs(bctx, 1/feet_per_meter * pixels_per_meter, part.x, part.y, rotated)
        bctx.stroke()
    }
    */

    bctx.strokeStyle = original_color
    bctx.lineWidth = original_width

    draw_pit_lines(blue_pit_lines, pixels_per_meter)
    draw_pit_lines(red_pit_lines, pixels_per_meter)

    original_width = bctx.lineWidth
    original_color = bctx.strokeStyle
    bctx.lineWidth = 1.375/12 * pixels_per_meter / feet_per_meter

    /*
    for (let part of cryptobox_columns) {
        bctx.beginPath()
        bctx.strokeStyle = colors[part.color]
        let rotated = rotate_vecs(part.part, part.angle)
        draw_vecs(bctx, 1/feet_per_meter * pixels_per_meter, part.x, part.y, rotated)
        bctx.stroke()
    }
    */

    bctx.strokeStyle = original_color
    bctx.lineWidth = original_width

    original_width = bctx.lineWidth
    original_color = bctx.strokeStyle
    bctx.lineWidth = 1/12 * pixels_per_meter / feet_per_meter

    bctx.strokeStyle = "#DDDDDD"

    /*
    bctx.beginPath()
    for (let part of pictures) {
        draw_vecs(bctx, 1/feet_per_meter * pixels_per_meter, part.x, part.y, part.part)
    }
    bctx.stroke()
    */

    bctx.strokeStyle = original_color
    bctx.lineWidth = original_width
}

var field_drawn = false

function view(model) {
    if (!field_drawn) {
        draw_field(model.pixels_per_meter)
        field_drawn = true
    }

    ctx.clearRect(0, 0, canvas.width, canvas.height)

    let wheel = [
        { x: model.wheel_thickness/2, y: model.wheel_radius },
        { x: model.wheel_thickness/2, y: -model.wheel_radius },
        { x: -model.wheel_thickness/2, y: -model.wheel_radius },
        { x: -model.wheel_thickness/2, y: model.wheel_radius }
    ]

    let regular_body = [
        { x: -model.width/2 + model.wheel_thickness, y: model.height/2 },
        { x: -model.width/2 + model.wheel_thickness, y: -model.height/2 },
        { x: model.width/2 - model.wheel_thickness, y: -model.height/2 },
        { x: model.width/2 - model.wheel_thickness, y: model.height/2 }
    ]

    let inches_to_meters = 0.0254

    let corner = 6 * inches_to_meters
    let wheel_distance = Math.sqrt(Math.pow(corner, 2) + Math.pow(2 * inches_to_meters, 2))

    let omni_body = [
        { x: -model.width/2 + corner, y: model.height/2 },
        { x: -model.width/2, y: model.height/2 - corner },
        { x: -model.width/2, y: -model.height/2 + corner },
        { x: -model.width/2 + corner, y: -model.height/2 },
        { x: model.width/2 - corner, y: -model.height/2 },
        { x: model.width/2, y: -model.height/2 + corner },
        { x: model.width/2, y: model.height/2 - corner },
        { x: model.width/2 - corner, y: model.height/2 }
    ]

    var body = []
    if (model.robot_type == "Omni Drive") {
        body = omni_body
    } else {
        body = regular_body
    }

    let forward_arrow = [
        { x: 0, y: -.05 },
        { x: -.1, y: -.15 },
        { x: .1, y: -.15 }
    ]

    let robot_parts = [
        { part: body, x: 0, y: 0, color: "orange" },
        { part: body, x: 0, y: 0, color: "blue", stroke: true },
        { part: forward_arrow, x: 0, y: model.height/2, color: "black"}
    ]

    for (let part of robot_parts) {
        draw_robot_part(part, model.heading, model.pos, model.pixels_per_meter)
    }

    let SixWheelOmni = [
        { part: wheel, x: -model.width/2 + model.wheel_thickness/2, y: model.height/3, color: "black" },
        { part: wheel, x: -model.width/2 + model.wheel_thickness/2, y: 0, color: "black" },
        { part: wheel, x: -model.width/2 + model.wheel_thickness/2, y: -model.height/3, color: "black" },
        { part: wheel, x: model.width/2 - model.wheel_thickness/2, y: model.height/3, color: "black" },
        { part: wheel, x: model.width/2 - model.wheel_thickness/2, y: 0, color: "black" },
        { part: wheel, x: model.width/2 - model.wheel_thickness/2, y: -model.height/3, color: "black" }
    ]

    let Mecanum = [
        { part: wheel, x: -model.width/2 + model.wheel_thickness/2, y: model.height/4, color: "black" },
        { part: wheel, x: -model.width/2 + model.wheel_thickness/2, y: -model.height/4, color: "black" },
        { part: wheel, x: model.width/2 - model.wheel_thickness/2, y: model.height/4, color: "black" },
        { part: wheel, x: model.width/2 - model.wheel_thickness/2, y: -model.height/4, color: "black" }
    ]

    let SlideDrive = [
        { part: wheel, x: -model.width/2 + model.wheel_thickness/2, y: model.height/4, color: "black" },
        { part: wheel, x: -model.width/2 + model.wheel_thickness/2, y: -model.height/4, color: "black" },
        { part: wheel, x: 0, y: 0, color: "black", initial_angle: 1.57 },
        { part: wheel, x: model.width/2 - model.wheel_thickness/2, y: model.height/4, color: "black" },
        { part: wheel, x: model.width/2 - model.wheel_thickness/2, y: -model.height/4, color: "black" }
    ]

    let wheel_corner = 2.3 * inches_to_meters
    let OmniDrive = [
        { part: wheel, x: -model.width/2 + wheel_corner, y: model.height/2 - wheel_corner, color: "black", initial_angle: -0.785398 },
        { part: wheel, x: -model.width/2 + wheel_corner, y: -model.height/2 + wheel_corner, color: "black", initial_angle: 0.785398 },
        { part: wheel, x: model.width/2 - wheel_corner, y: model.height/2 - wheel_corner, color: "black", initial_angle: 0.785398 },
        { part: wheel, x: model.width/2 - wheel_corner, y: -model.height/2 + wheel_corner, color: "black", initial_angle: -0.785398 }

    ]

    var wheel_parts = []
    if (model.robot_type == "Mecanum") {
        wheel_parts = Mecanum
    } else if (model.robot_type == "6 Wheel Omni") {
        wheel_parts = SixWheelOmni
    } else if (model.robot_type == "Slide Drive") {
        wheel_parts = SlideDrive
    } else if (model.robot_type == "Omni Drive") {
        wheel_parts = OmniDrive
    }

    for (let part of wheel_parts) {
        draw_robot_part(part, model.heading, model.pos, model.pixels_per_meter)
    }
}

export { initBackground, init, canvas, ctx, view }



//////////////////
// WEBPACK FOOTER
// ./src/canvas.js
// module id = 5
// module chunks = 0